// removed by extract-text-webpack-plugin
module.exports = {"root":"_9q1LS","actionPanel":"_3dJU8","itemMeta":"_7H2LP","cartButtons":"VRlLl"};